var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MacroModulatorBoxAdapter_instances, _MacroModulatorBoxAdapter_wrapParameters;
import { ValueMapping } from "@opendaw/lib-std";
import { ModulatorBoxAdapter, polarityStringMapping } from "./ModulatorBoxAdapter";
export class MacroModulatorBoxAdapter extends ModulatorBoxAdapter {
    constructor(context, box) {
        super(context, box);
        _MacroModulatorBoxAdapter_instances.add(this);
        this.namedParameter = __classPrivateFieldGet(this, _MacroModulatorBoxAdapter_instances, "m", _MacroModulatorBoxAdapter_wrapParameters).call(this, box);
        this.registerParameterTracks();
    }
}
_MacroModulatorBoxAdapter_instances = new WeakSet(), _MacroModulatorBoxAdapter_wrapParameters = function _MacroModulatorBoxAdapter_wrapParameters(box) {
    return {
        value: this.parametric.createParameter(box.value, ValueMapping.unipolar(), polarityStringMapping(box.bipolar), "Value")
    };
};
